<!-- @format -->

<fudis-dialog *transloco="let t">
  <fudis-heading fudisDialogTitle [level]="2" [variant]="'lg'">
    {{ t("TIMELINE.TIMING_TEMPLATE.TITLE") }}
  </fudis-heading>
  <fudis-dialog-content class="fudis-pb-lg">
    <fudis-body-text class="fudis-mb-sm">{{ t("TIMELINE.TIMING_TEMPLATE.MODAL_GUIDANCE") }}</fudis-body-text>
    <ul>
      <li>
        <transloco [key]="'TIMELINE.TIMING_TEMPLATE.MODAL_INFO_1'" />
      </li>
      <li>
        <transloco [key]="'TIMELINE.TIMING_TEMPLATE.MODAL_INFO_2'" />
      </li>
    </ul>
    @if (firstLevelModules$ | async; as modules) {
      @if (modules.length === 0) {
        <fudis-notification [variant]="'warning'" class="fudis-mt-lg">
          <fudis-body-text>{{ t("TIMELINE.TIMING_TEMPLATE.NO_FIRST_LEVEL_MODULES_NOTIFICATION") }}</fudis-body-text>
        </fudis-notification>
      }
      @for (module of modules; track module.id) {
        <app-module-timing-template
          [class]="'fudis-mt-md'"
          [module]="module"
          (selectedTemplate)="updateSelectedTimingTemplates(module, $event)" />
      }
    }
  </fudis-dialog-content>
  <fudis-dialog-actions>
    <fudis-button fudisDialogClose [variant]="'secondary'" [label]="t('SIS_COMPONENTS.BUTTON.CANCEL')" />
    <fudis-button [label]="t('TIMELINE.TIMING_TEMPLATE.ADD_BUTTON')" (handleClick)="introduceTimingTemplates()" />
  </fudis-dialog-actions>
</fudis-dialog>
